import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';

import { addTranslation, IntlProps } from 'decorators/addTranslation';
import { StoreProps } from 'store';

import Button from 'components/ui/button';

import { DictionaryMultiSelect } from 'types/FilterValue';
import {
  changeQuickFilter,
  resetConcreteQuickFilters,
} from 'actions/quickFilters';
import tableNames from 'constants/tableNames';
import filtersKeys from 'constants/filters';

interface OwnProps {
  showCreateForm: boolean;
  isLoading: boolean;
  isFetched: boolean;
  balanceType: DictionaryMultiSelect;
  onToggle: () => void;
  onDownload: () => void;
}

type Props = OwnProps & StoreProps & IntlProps;

class TopPanel extends PureComponent<Props> {
  render() {
    const { showCreateForm, isLoading, isFetched } = this.props;
    const { getTranslate, onToggle, onDownload } = this.props;

    return (
      <Fragment>
        <Button
          text={getTranslate('statement.buttons.createStatement')}
          status='primary'
          disabled={showCreateForm}
          onClick={onToggle}
        />
        <span>
          <Button
            status='light'
            icon='im-Reset-filter'
            disabled={isLoading}
            onClick={this.onResetFilters}
          />
          <Button
            status='light'
            icon='im-Download1'
            disabled={isLoading || !isFetched}
            onClick={onDownload}
          />
        </span>
      </Fragment>
    );
  }

  onResetFilters = () => {
    const { balanceType, dispatch } = this.props;

    dispatch(resetConcreteQuickFilters({ name: tableNames.balanceStatement }));

    if (balanceType?.isFetched) {
      dispatch(
        changeQuickFilter(
          tableNames.balanceStatement,
          filtersKeys.balanceStatementBalanceType,
          balanceType.list[0].id
        )
      );
    }
  };
}

export default connect()(addTranslation(TopPanel));
